



































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class Kjqy extends Vue {
    @Prop({ type: [Number, String] })
    year!: number;
    form = {
        accountBookId: this.$store.state.accountBook.id,
        year: this.year,
        number: "",
        technologyNum: "",
        technologyFund: "",
    }

    mounted() {
        this.fetchData();
    }
    async save() {
        const keys = Object.keys(this.form);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            // @ts-ignore
            if (key != "gmtCreate" && key != "gmtModified" && key != "id") {
                // @ts-ignore
                if (this.form[key] === null || this.form[key] === "") {
                    this.$notify({
                        title: "温馨提示",
                        message: "请将所有信息填写完整",
                        type: "warning"
                    });
                    return;
                }
            }

        }
        await Vue.axios.post(`gsnb/kjqyxxcj/save`, this.form);
        this.fetchData()
        this.$emit("update", this.form);
    }
    async fetchData() {
        const res = await Vue.axios.get(`gsnb/kjqyxxcj/get?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        if (res.data.data) {
            this.form = res.data.data
        }
    }


}
